import { Component, OnInit } from '@angular/core'
import { AuthService } from './login/services/auth.service'
import { lastValueFrom } from 'rxjs'
import { Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { TransitionService } from './shared/services/transition.service'
import { ThemeService } from './shared/services/theme.service'
@Component({
  selector: 'eld-root',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  public showTransition = this.transitionService.showTransition$

  constructor (
    public authService: AuthService,
    private router: Router,
    public _translate: TranslateService,
    public transitionService: TransitionService,
    private themeService: ThemeService
  ) {}

  //this is needed to get user info
  //when reloading or initialising
  public async ngOnInit (): Promise<void> {
    //apply the saved light/dark theme preference
    this.themeService.init()

    // Load user if already logged in
    const isLoggedIn = this.authService.loggedIn.value

    if (isLoggedIn) {
      try {
        await lastValueFrom(this.authService.getMe())

        // Only redirect to dashboard if current URL is root or login
        if (['/', '/login'].includes(this.router.url)) {
          await this.router.navigateByUrl('/dashboard')
        }
      } catch {
        this.authService.logout()
      }
    } else {
      this.authService.logout()
    }
  }
}
